import { useCallback, useEffect, useState } from "react";
import { API } from "../lib/api";
import { readServerVersion } from "../lib/appVersion";
import useVisiblePolling from "./useVisiblePolling";

const CHECK_EVERY_MS = 5 * 60 * 1000;

// The version the server runs now (public `GET /api/version`). Read through `fetch`, not the axios instance: a failure here must never
// trigger the session-refresh or rights-refresh handlers. A network failure just keeps the last known value.
export default function useServerVersion() {
  const [version, setVersion] = useState(null);
  const check = useCallback(async () => {
    try {
      const response = await fetch(`${API}/version`, { cache: "no-store", credentials: "same-origin" });
      if (!response.ok) return;
      setVersion(readServerVersion(await response.json()));
    } catch {
      /* offline or server restarting: keep what we knew */
    }
  }, []);
  useEffect(() => { check(); }, [check]); // the first read is ours; the polling only refreshes
  useVisiblePolling(check, CHECK_EVERY_MS);
  return version;
}
